/** @jsx h */
import { h } from 'preact'

import t from '../../../utils/translate'

const MeaningSection = ({ title, summaryArray }) => {
  if (summaryArray.length === 0) return null

  return (
    <section class='ModalCard-section'>
      <h3 class='ModalCard-heading'>
        {t('proof_points.js.meaning.what', { title })}
      </h3>
      <ul class='ModalCard-list'>
        {summaryArray.map(item => (
          <li class='ModalCard-listItem' key={item}>
            {item}
          </li>
        ))}
      </ul>
    </section>
  )
}

MeaningSection.defaultProps = {
  summaryArray: []
}

export default MeaningSection
